import styled, { css } from 'styled-components';
import {
  SPACING_0,
  SPACING_4,
  SPACING_8,
  SPACING_16,
  SPACING_24,
  SPACING_32
} from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { NEUTRAL_GREY_350 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import { BODY } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { BORDER_BOX } from 'common';
import { RADIUS_2 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/border-radius';

const DEFAULT_TOGGLE_BUTTON = css`
  display: flex;
  align-items: center;
  button {
    padding: ${SPACING_0};
    height: ${SPACING_32};
    width: ${SPACING_32};
    margin: 0;
  },
`;

const GENERAL_INPUT_STYLE = css`
  height: ${props => (props.compactMode ? SPACING_24 : SPACING_32)};
  display: inline-block;
  width: 100%;
  border-radius: 0.125rem;
  border: none;
  outline: none;
  padding: 0 ${SPACING_8};
  background: ${({ $theme }) => $theme.input.background};
  ${BODY}
  &:focus {
    background: ${({ $theme }) => $theme.cell.normal.background};
    ${({ $theme }) => `box-shadow: inset 0 0 0 0.125rem ${$theme.cell.editable.focus.border}`};
  }
`;

export const GENERAL_INPUT_STYLE_DATE = {
  display: 'inline-block',
  width: '100%',
  borderRadius: RADIUS_2,
  border: 'none',
  outline: 'none',
  padding: `0 ${SPACING_8}`,
  marginTop: SPACING_4,
  BORDER_BOX,
};

export default {
  // Make row action MoreButton vertically align center.
  RowActionsWrapper: styled.div`
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${props =>
    css`
        opacity: ${props.alwaysShow || props.isMenuOpen ? '1' : '0'};
      `}

    .ag-row-hover:not(.ag-full-width-row)  & {
      opacity: 1;
    }
    .ag-row-focus:not(.ag-full-width-row) & {
      opacity: 1;
    }
    .ag-row-selected & {
      opacity: 1;
    }
  `,
  ColorBarWrapper: styled.div`
    height: 100%;
    width: ${SPACING_8};
    background-color: ${({ value }) => value};
  `,
  IconWrapper: styled.div`
    height: 100%;
    padding: 0 ${SPACING_8} 0 ${SPACING_16};
    display: flex;
    justify-content: center;
    align-items: center;

    & div > div {
      display: flex;
    }
  `,
  ToggleButtonContainer: styled.div`
    outline: none;
    height: 100%;
    ${DEFAULT_TOGGLE_BUTTON}
  `,

  CellEditorBorder: styled.div`
   ${BORDER_BOX}
    height: ${props => (props.compactMode ? SPACING_24 : SPACING_32)};
    line-height: ${props => (props.compactMode ? SPACING_24 : SPACING_32)};
    display: inline-block;
    width: 100%;
    background: transparent;
    outline: none;
    padding: 0 ${SPACING_8};
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  CellEditorWrapper: styled.div`
    height: 100%;
    width: 100%;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    outline: none;
  `,
  EditingInput: styled.input`
    ${BORDER_BOX}
    &:hover {
      box-shadow: inset 0 0 0 0.0625rem ${NEUTRAL_GREY_350};
    }
    ${GENERAL_INPUT_STYLE}
    color: ${({ $theme }) => $theme.cell.color};
    ${({ $rtl }) =>
    $rtl &&
      css`
        direction: rtl;
      `}
    position: relative;
  `,
  FloatingFilterInput: styled.input`
  ${BORDER_BOX}
  ${GENERAL_INPUT_STYLE}
  box-shadow: ${({ $theme }) => `inset 0 0 0 0.0625rem ${$theme.input.border}`};
  ${({ $rtl }) =>
    $rtl &&
    css`
      direction: rtl;
    `}
    margin-top: 0.25rem;

    color: ${({ $theme }) => $theme.header.floatingFilter.color};
  `,
  CheckboxCell: styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 ${SPACING_8};

    & > span {
      margin: 0 0.375rem;

      & svg {
        position: absolute;
      }
    }
  `,
  ColorBar: styled.div`
    height: 100%;
    display: flex;
  `
};
